import React, { Fragment, useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import SideNav from '../../Components/SideNav';
import Loader from '../../Components/Loader';

import PopHelper from '../../Helpers/Pop';

const POP_ID = 1;

const Pop = () => {
    const [pop, setPop] = useState({ fecha: "" });
    const [flag, setFlag] = useState(false);

    useEffect(() => {
        obtenerPop();
    }, []);

    const obtenerPop = async () => {
        let res = await PopHelper.obtenerPop(POP_ID);
        if (res.success) {
            setPop(res.data);
            setFlag(true);
        } else {
            Swal.fire(
                'Error!',
                'No se pudo obtener el pop, codigo: ' + res.code,
                'error'
            );
        }
    };

    const leerDato = e => {
        setPop({
            ...pop,
            [e.target.name]: e.target.value
        });
    };

    const actualizarPop = e => {
        e.preventDefault();
        PopHelper.editarPop(pop, POP_ID);
    };

    return (
        <Fragment>
            <SideNav />
            <div className='row'>
                <div className='col s12' style={{ padding: "40px" }}>
                    <p className='titulo_1_admin'>Pop — Fecha de activación</p>
                    {!flag ? (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "60vh" }}>
                            <Loader />
                        </div>
                    ) : (
                        <form onSubmit={actualizarPop} style={{ maxWidth: "400px" }}>
                            <div className="input-field">
                                <input
                                    onChange={leerDato}
                                    defaultValue={pop.fecha}
                                    id="fecha"
                                    name='fecha'
                                    type="text"
                                    className="validate"
                                />
                                <label className='active' htmlFor="fecha">Fecha</label>
                            </div>
                            <div className='botonn_1_admin' style={{ marginTop: "10px" }}>
                                <button type='submit'>
                                    Actualizar pop
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default Pop;
